module.exports = "/static/assets/6f705ff4dc4bed3d9dd1d96d476c0348.png";